module.exports = __webpack_public_path__ + "img/topic_emo_connect.d8520463.svg";